import { captureException } from '@sentry/browser'

/**
 * This class works a a simple type class ensuring that all rows get parsed in a similar way.
 * This is not a necessary class to use, but it simplifies and standardises converting data into a row object for use
 *
 * Feel free to extend or replace this class if the need arises
 *
 * TODO: When we switch to typescript this class should/could be replaced by and interface or similar
 */
export default class Row {
  _row: any

  get row() {
    return this._row // _row is used for now since private properties aka #row is not yet supported
  }

  constructor(data) {
    const extract = (d) => {
      if (typeof d === 'string') {
        return { ...JSON.parse(d) }
      }
      if (Object.keys(d).length >= 2 && d.data !== undefined) {
        // Simply if we have a d.data object and nothing else that likely means we got some query object.
        // So we grab our data from our data and try to parse that into a row type instead
        return extract(d.data) // We recursively extract the data
      }
      return { ...d }
    }

    this._row = extract(data)

    // Allows to access all underlying values as if they where part of this object.
    // But does not allow to set any of the values
    // eslint-disable-next-line no-constructor-return
    return new Proxy(this, {
      get(target, prop) {
        try {
          if (prop === 'row' || prop === '_row') {
            return target.row
          }

          return target._row[prop]
        } catch (e) {
          captureException(e)
          throw e
        }
      },
    })
  }
}
